var _path, _g, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgKmxIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 23 23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "c",
    width: 23,
    height: 23,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#b)",
    d: "M11.5 0C17.8513 0 23 5.14873 23 11.5 23 17.8513 17.8513 23 11.5 23 5.14873 23 0 17.8513 0 11.5 0 5.14873 5.14873 0 11.5 0Z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#c)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#d)",
    d: "M11.9839 20.7817c3.901 0 7.0634-3.0601 7.0634-6.8349 0-3.7749-3.1624-6.83498-7.0634-6.83498-3.90107 0-7.06349 3.06008-7.06349 6.83498 0 3.7748 3.16242 6.8349 7.06349 6.8349Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#e)",
    fillRule: "evenodd",
    d: "M13.1626 7.14177C11.8251 6.14175 9.6765 5.80563 9.36274 3.8855c-.59121.55531-.93482 1.22337-.81671 2.1008-3.31749.35644-5.69871 2.12953-6.79505 4.8256.75965-.399 1.58185-.6698 2.43244-.8011-2.0632 2.3248-2.4545 5.7681-.56916 9.2771.10416-.8419.38938-1.6524.83666-2.3774.67873 2.8473 3.08674 4.8704 5.63378 5.4656-3.57487-1.648-4.68042-4.2968-3.33866-6.481.18073-1.2829.74776-2.3312 1.76795-3.1113-.82431-.1739-1.68077-.13-2.48224.1275 1.30169-1.0767 2.97834-1.6117 4.67425-1.4916-.4931-.4833-1.09486-.8455-1.75657-1.0574 3.64757-.41038 6.31967 2.5829 8.48747.8364-2.6572-.8789-2.7411-2.91484-4.2743-4.05693Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#f)",
    fillRule: "evenodd",
    d: "M4.12671 8.74207c-.95311.48016-1.77745 1.18529-2.40308 2.05573.75215-.4057 1.56633-.6813 2.40871-.81519.79924-.90374 1.78888-1.61519 2.89625-2.08198-1.26816.33931-2.32489.85709-3.2006 1.52434l.29872-.6829Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M12.8148 8.30416c-.4768-.15461-.9921.23931-1.3861.15741.3519.13762.748.68895 1.167.7666.4032.07558.6965-.10657 1.0948 0-.3355-.17079-.3983-.76872-.8757-.92401Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#g)",
    fillRule: "evenodd",
    d: "M19.5034 7.24303c.0242.94317-.1114 1.75695-.4501 2.41279-1.0762-4.15717-5.7761-5.82885-5.4154-9.423886-2.3855 1.188556-3.4887 3.516036-2.176 5.955406.5679.29429 1.1558.56837 1.6371.92847 1.5299 1.14029 1.6904 3.20489 4.3371 4.08229-1.7508 3.7468-8.1353.3993-10.74152 4.6571-1.33897 2.1828-.39902 5.2059 3.34312 6.5154 3.5242.825 7.8017-.5593 10.0735-3.3301-1.1122.2662-2.2733.2624-3.3836-.0112 4.9944-1.9541 6.0011-8.0486 2.7758-11.78627Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#h)",
    fillRule: "evenodd",
    d: "M6.42905 15.8245c-1.37203 2.171-.40887 5.178 3.42566 6.4804-2.81167-1.283-3.32093-3.616-2.18607-5.4178 2.093-3.3165 8.35146-.4646 9.96066-3.8074-.4667-.1469-.9093-.3563-1.3146-.6217-2.8885 1.4481-7.62395-.2225-9.88565 3.3665Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#i)",
    fillRule: "evenodd",
    d: "M11.4461 6.18305c.6406.32147.6953.34498 1.2035.63689-1.0571-2.40225-.4382-4.38789.9613-6.574823-2.3677 1.187843-3.4677 3.500003-2.1648 5.937933Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#j)",
    fillRule: "evenodd",
    d: "M19.0433 9.64359c-.5822-2.26429-1.9809-3.51348-3.3181-4.99955 2.1717 2.78083 3.1391 5.76596 2.1593 9.08566.6358-.1892 1.214-.5327 1.6825-.9994.0818 3.2112-2.1935 6.013-6.2521 6.9222 1.2941-.0104 2.4332-.2344 3.4171-.6236 4.9608-1.9563 5.9603-8.0576 2.7582-11.79937.0239.9428-.1107 1.75754-.4469 2.41406Z",
    clipRule: "evenodd"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M6.5818 15.4428c0 .2518-.20413.4559-.45594.4559s-.45594-.2041-.45594-.4559v-2.9559c0-.2518.20413-.4559.45594-.4559s.45594.2041.45594.4559v.073c0 .4881.60467.7157.92654.3489l.65416-.7456c.0737-.084.18003-.1322.29178-.1322.33423 0 .51219.3943.29111.6449l-.50423.5717c-.21667.2456-.24385.6053-.06656.8807l.70793 1.0997c.18641.2896-.0215.6707-.36589.6707-.1484 0-.28657-.0756-.36654-.2006l-.43065-.6731c-.22129-.3459-.71226-.3835-.98361-.0753l-.01385.0157c-.09035.1026-.14019.2346-.14019.3714v.106ZM14.2581 15.4444c0 .2509-.2034.4543-.4544.4543-.2509 0-.4543-.2034-.4543-.4543v-2.3076c0-.0539-.0127-.1043-.0382-.151-.0233-.0468-.0561-.0872-.0984-.1214-.0403-.0359-.088-.0638-.143-.0836-.0551-.0198-.1144-.0297-.1779-.0297-.0636 0-.1229.0099-.178.0297-.055.0198-.1038.0477-.1461.0836-.0403.0342-.072.0746-.0953.1214-.0233.0467-.035.0971-.035.151v2.306c0 .2518-.2041.4559-.4559.4559s-.456-.2041-.456-.4559v-2.306c0-.0539-.0116-.1043-.0349-.151-.0233-.0468-.0562-.0872-.0985-.1214-.0403-.0359-.0879-.0638-.143-.0836-.0551-.0198-.1144-.0297-.1779-.0297-.0636 0-.1229.0099-.178.0297-.055.0198-.1037.0477-.1461.0836-.0403.0342-.072.0746-.0953.1214-.0233.0467-.035.0971-.035.151v2.306c0 .2518-.2041.4559-.4559.4559-.25182 0-.45595-.2041-.45595-.4559v-2.306c0-.16.03495-.3101.10485-.4504.07202-.142.16946-.2652.2923-.3695.125-.1061.2701-.1888.4353-.2481.1673-.0612.3453-.0917.5338-.0917.1694 0 .3325.026.4893.0782.2669.0857.5754.0868.842 0 .1567-.0522.3198-.0782.4893-.0782.1885 0 .3653.0305.5306.0917.1673.0593.3124.142.4352.2481.125.1043.2224.2275.2923.3695.0721.1403.1081.2904.1081.4504v2.3076ZM18.1023 15.1907c.2134.2952.0025.708-.3618.708-.1455 0-.2818-.0708-.3654-.1899l-.1015-.1444c-.3127-.4453-.9723-.4459-1.2858-.0011l-.1037.1471c-.0832.1181-.2186.1883-.363.1883-.3624 0-.5722-.4106-.3599-.7043l.5117-.7079c.2251-.3113.2251-.732 0-1.0433l-.5117-.7079c-.2123-.2937-.0025-.7043.3599-.7043.1444 0 .2798.0702.363.1883l.1037.1471c.3135.4448.9731.4442 1.2858-.0011l.1015-.1444c.0836-.1191.2199-.1899.3654-.1899.3643 0 .5752.4128.3618.708l-.5091.7042c-.225.3113-.225.732 0 1.0433l.5091.7042Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "b",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(28.64012 -36.2583 46.8239 36.98579 -5.63575 28.1027)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#25FF01"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#02F0FF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "e",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(13.9583 18.55023 -17.95797 13.51266 3.55724 3.87808)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#41E6AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#02F0FF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "f",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(4.11532 2.18803 -2.34332 4.40738 2.91424 9.63705)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F82FF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#02F0FF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(58.916 3.739561 7.075424) scale(26.1476 23.2958)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#41E6AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2EB1D4"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "h",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(10.44283 9.85478 -9.91195 10.50342 7.18874 12.4541)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3190C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2BD6E3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "i",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(70.755 5.42143 7.975613) scale(7.29708 4.57553)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#41E6AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#41ABE6"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "j",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(7.1017 15.31406 -11.77708 5.46147 14.1571 4.34462)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2FFFDA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#33BFCB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 4.92041,
    x2: 4.31227,
    y1: 17.679,
    y2: 18.4583,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23A0BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#00F2DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#00D0D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.502682,
    stopColor: "#00677E",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#009ACD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0064C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1FB986"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h23v23H0z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKmxIcon);
export default __webpack_public_path__ + "static/media/kmx-icon.1209080f.svg";
export { ForwardRef as ReactComponent };